import { State } from 'types/redux';

export const getOrchestrationStatus = (state: State) => state.orchestration.status;
export const getOrchestrationError = (state: State) => state.orchestration.error;
export const getOrchestrationVSBInitResponse = (state: State) =>
  state.orchestration.vsbInitResponse;
